<!-- Tracked by organization on purpose: a new key rebuilds the content (Angular logs NG0956 in dev). -->
@for (key of [organizationKey()]; track key) {
  <app-import-shell-content />
}
